import { createClassName } from 'utils/createClassName';

import './accountControlsDesktopLayoutStyles.scss';

export const createAccountControlsDesktopLayoutClassName = createClassName(
  'accountControlsDesktopLayout'
);
